import React from 'react'

import Lightbox from 'react-image-lightbox'


const styleBody = {
  overlay : {
    position          : 'fixed',
    top               : '0px',
    left              : '0px',
    right             : '0px',
    bottom            : '0px',
    backgroundColor   : 'rgba(255, 255, 255, 0.75)'
  },
  content : {
    position                   : 'absolute',
    border                     : '1px solid #ccc',
    background                 : '#fff',
    overflow                   : 'none',
    WebkitOverflowScrolling    : 'touch',
    borderRadius               : '4px',
    outline                    : 'none', 
    width: 'calc(100%-300px)'
  }
}

class HSGFilePreview extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      photoIndex: 0,
      imgUrl: this.props.imgUrl,
      pdf: false,
      img: false,
      position: 'right',
      isOpen: this.props.isOpen
    }
  
  }

  checkPdf = (getPdfOrImg) => {

    if(getPdfOrImg == "application/pdf" || typeof getPdfOrImg === "undefined") {
      this.setState({
        pdf: true,
        img:false
      })
    } else {
      this.setState({
        img: true,
        pdf: false
      })
    }

  }

  componentWillMount() {
  
    const imgUrl = this.props.imgUrl
    const photoIndex = this.props.photoIndex
    
    this.setState({imgUrl: imgUrl, photoIndex: photoIndex})

    let getPdfOrImg = this.props.imgUrl[photoIndex].mimeType
    this.checkPdf(getPdfOrImg)

  } 

  componentWillReceiveProps(nextProps) {
    this.setState({imgUrl: nextProps.imgUrl, isOpen: nextProps.isOpen, })
    this.setState({photoIndex: nextProps.photoIndex})

    const getPdfOrImg = nextProps.imgUrl[nextProps.photoIndex].mimeType
    this.checkPdf(getPdfOrImg)
  }

  closeLightbox = () => {
    this.props.togglePreview(false)

    this.setState({
      pdf: false,
      img: false
    })
  }

  previous = () => {
    let photoIndex = (this.state.photoIndex + this.state.imgUrl.length - 1) % this.state.imgUrl.length

    this.setState({
      photoIndex: photoIndex
    })

    let getPdfOrImg = this.state.imgUrl[photoIndex].mimeType
    this.checkPdf(getPdfOrImg)
  }

  next = () => {
    let photoIndex = (this.state.photoIndex + 1) % this.state.imgUrl.length;
 
    this.setState({
      photoIndex: photoIndex
    })

    let getPdfOrImg = this.state.imgUrl[photoIndex].mimeType
    this.checkPdf(getPdfOrImg)
  }

  // showImgInfo = () => {
  //   this.setState({
  //     openDrawer: !this.state.openDrawer
  //   })
  //   if(!this.state.openDrawer) {
  //     styleBody.content = Object.assign({}, styleBody.content, {
  //       width: 'calc(100%-300px)'
  //     })
  //   }
  // }

  // renderImgDetail = () => {
  //   return (
  //     <div>
  //       <span onClick={()=>this.showImgInfo()} style={{fontSize: '22px', padding: '10px'}} className="fa fa-info-circle"></span>
  //     </div>
  //   )
  // }


  renderTitle = (doc) => {

    return(
      <div>
        <span onClick={()=>this.closeLightbox()} className="fa fa-arrow-left"></span>
        <span style={{paddingLeft: '10px'}}>{this.state.photoIndex + 1+' of ' + this.state.imgUrl.length}</span>
      </div>
    )
  }

  deleteButton = (doc) => {

    return  <div>
              <span onClick={() => this.props.removeDoc(doc.id, doc.uuid, this.props.showFlag, this.props.fileGroup, this.state.imgUrl)} aria-hidden="true" data-icon="&#e90f;" className="icon-delete hsg-preview-delete"></span>
            </div>
  }

  renderPDF = () => {
    const { photoIndex } = this.state
    let preview = null

    const iframeURL = this.state.imgUrl && this.state.imgUrl[photoIndex].contentUrl
  
    preview = <div className="hsg-preview-pdf"> 
                <iframe className="hsg-preview-pdf-frame"  src={ iframeURL } frameBorder={ 0 }/>
              </div>
    
    return(
      <div>
        {this.state.pdf && preview }        
      </div>
    )
  }

  render() {
    const { photoIndex } = this.state

    return  <div>
              {
                this.state.imgUrl && this.state.imgUrl.length > 0 && this.props.isOpen &&
                  <Lightbox
                      reactModalStyle={styleBody}
                      mainSrc={this.state.imgUrl[photoIndex].contentUrl}
                      nextSrc={this.state.imgUrl[photoIndex].contentUrl}
                      prevSrc={this.state.imgUrl[photoIndex].contentUrl}
                      onMovePrevRequest={() => this.previous()}
                      onMoveNextRequest={() => this.next()}
                      onCloseRequest={() => {this.closeLightbox()}}
                      imageTitle={this.renderTitle(this.state.imgUrl[photoIndex])}
                      toolbarButtons={[this.renderPDF()]}
                      discourageDownloads={false}
                  />
              }
            </div>
  }

}

export default HSGFilePreview


// WEBPACK FOOTER //
// ./src/Containers/HealthLockerContainer/Component/HSGFilePreview.js